<template lang="pug">
	main(id="panel")

		header(v-if="$route.name=='home'")
			.logo-wrap
				.logo
					img.logo__img(src="../assets/logo.png")
					.logo__text Школа аргентинского танго в Зеленограде


			flickity(ref="flickity" :options="flickityOptions" class="slider" v-if="loaded")
				img.slider__cell(v-for="photo in items.headerPhotos"  :data-flickity-lazyload="photo.fields.file.url")
				//:data-flickity-bg-lazyload="photo.fields.file.url"
				//:style="'background-image:url('+photo.fields.file.url+')'"
		.menu-wrap
			menu.menu
				router-link(to="/" class="menu__item") Главная
				router-link(to="/faq" class="menu__item") ЧаВо
				router-link(to="/about" class="menu__item") О школе
				router-link(to="/schedule" class="menu__item") Расписание
				router-link(to="/links" class="menu__item") Полезные ссылки
				.menu__item.menu__item_register(@click="toggleSignup") Записаться

		.signup-wrap(v-if="showSignup")

			.signup
				.signup-cross(@click="toggleSignup") ✕
				h1 {{items.signupHead}}
				p
					//- vue-markdown {{items.signupText}}
				form(v-if="!formSubmitted")
					.firstline
						.inputcont
							input(placeholder="Имя" v-model="form.name")
						.inputcont
							input(placeholder="Телефон" type="phone"  v-model="form.phone")
						.inputcont
							input(:placeholder="valerrors.email?'Е-мейл обязателен!':'Е-мейл'" type="email" v-model="form.email" :class="valerrors.email?'error':''")


					textarea(placeholder="Какое направление вас интересует?" v-model="form.msg")

					.agreement
						input(type="checkbox" v-model="form.agreement" id="agree")
						label(for="agree" :class="valerrors.agreement?'error':''") Согласен на обработку персональных данных

					input(type="button" value="Записаться" @click="submit")

				.signup-submitted(v-if="formSubmitted") Форма отправлена. Скоро мы с вами свяжемся! Если этого не произойдет в течение 2 дней, пожалуйста, позвоните нам.


		section
			router-view(v-if="loaded")
			.loader(v-if="loading")
				.loader-item ◌

</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Flickity from "vue-flickity";
const axios = require('axios');
export default {
	name: "mainWrap",
	props: {

	},
	computed: {
		...mapGetters({
			items: "main/mainPageItems",
			loading: "main/loading",
			loaded: "main/loaded",
			showSignup: "main/showSignup"
		})
	},
	methods:{
		...mapMutations({toggleSignup:"main/toggleSignup"}),
		submit: function(){
			// console.log('submit aqui');
			if (!this.validate()) return false;

			axios.get(`https://bakeevopark.ru/actions/fm.php?name=${this.form.name}&phone=${this.form.phone}&email=${this.form.email}&msg=${this.form.msg}`)
			.then(this.submitted)
			.catch(function (error) {
				// console.log(error);
			})
			return false;
		},

		validate: function(){
			this.valerrors.email = (this.form.email.length==0 || this.form.email.indexOf('@')<=0)
			this.valerrors.agreement = !this.form.agreement;
			return !(this.valerrors.email || this.valerrors.agreement);
		},

		submitted: function(){
			this.formSubmitted = true;
		}


	},
	data() {
		return {
			flickityOptions: {
				initialIndex: 0,
				autoPlay: 5000,
				prevNextButtons: true,
				pageDots: true,
				wrapAround: true,
				lazyLoad: 1

				// any options from Flickity can be used
			},

			form:{
				name: '',
				phone: '',
				email: '',
				msg: '',
				agreement: false
			},
			formSubmitted: false,
			valerrors: {
				email: false,
				agreement: false
			}
		};
	},
	components: {
		Flickity
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.main-wrap
	padding 20px
	box-sizing border-box

	a
		color white
		display block
		margin-bottom 20px

.menu
	max-width 1000px
	margin 0 auto
	display flex
	justify-content space-between
	padding 0

	@media screen and (max-width: 1000px)
		display none

	&__item
		font-family Oswald
		text-transform uppercase
		text-decoration none
		color white
		padding 10px
		transition 1s all

		&_register
			background-color #71356f
			padding 10px 20px
			cursor pointer

		&:hover
			text-shadow 0 0 10px #ffffffff

	&-wrap
		background-color rgba(0, 0, 0, .5)
		transform translateY(-100%)
		z-index 1000000000
		position sticky
		top 44px
		transition .5s all
		// max-width 1000px
		margin 0 auto

		&:hover
			background-color rgba(0, 0, 0, .8)

header
	position relative
	box-sizing border-box
	background-color white
	// max-width: 1000px;
	// margin: 0 auto;
	width 100%

	.gradient
		position absolute
		top 0
		left 0
		right 0
		bottom 0
		z-index 9
		background linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .55) 25%, rgba(0, 0, 0, .6) 40%, rgba(0, 0, 0, .55) 55%, rgba(0, 0, 0, 0) 100%)
		// background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.6) 45%,rgba(0,0,0,0) 100%);

	.logo

		width: 40%;
		margin 0 auto

		@media screen and (max-width: 1000px)
			width 80%

		&-wrap
			padding: 30px 0;
			background-color #632d61

		&__img
			width 100%

		&__text
			text-align center
			letter-spacing 1px
			font-size 13px
			color white
			font-family Oswald
			text-transform uppercase

.slider
	width 100%

	.flickity-prev-next-button
		z-index 10

	&__cell
		width 1000px
		max-width 100%
		height 50vh
		display inline-block
		background-size cover
		object-fit cover
		background-position center

.loader
	display flex
	width 100%
	height 30vh
	align-items center
	justify-content center

	&-item
		font-size 10vw
		color #949494
		animation rotate 1.5s linear infinite
		height 13vw

@keyframes rotate
	to
		transform rotate(359deg)

.signup
	padding: 15px;
	box-sizing: border-box;
	background-color #e4c3dc
	padding: 25px 40px;
	border-radius: 15px;
	position relative

	&-submitted
		text-align center

	&-cross
		position absolute
		top 10px
		right 20px
		cursor pointer
		font-size 30px
		font-weight bold
		opacity .6

	&-wrap
		background-color rgba(0,0,0,0.8)
		position fixed
		top 0
		left 0
		bottom 0
		right 0
		z-index 1000000000
		display flex
		align-items center
		justify-content center

	h1
		color #524152

	p
		padding-bottom 10px

	a
		font-weight bold
		text-decoration none
		color #730073
		transition .3s all

		&:hover
			text-decoration underline
			color #d001d0

	form
		text-align center

	.firstline
		display flex
		justify-content space-between
		margin-bottom 15px

		@media screen and (max-width: 1000px)
			flex-wrap wrap
			margin-bottom 0

	.inputcont
		flex 1 0 33%
		box-sizing border-box
		padding-right 15px

		@media screen and (max-width: 1000px)
			flex 1 0 100%
			padding-right 0
			margin-bottom 15px

		&:last-child
			padding-right 0

		input
			padding 10px
			width 100%
			font-size 15px
			box-sizing border-box
			border-radius 6px
			border none
			background-color #f3dfff

			&.error
				box-shadow:inset 0px 0px 0px 1px #a2213c;

	.agreement
		display: flex;
		align-items: baseline;
		padding-top 10px

		label
			padding-left 5px

			&.error
				color #a2213c;

		input[type="checkbox"]
			transform: scale(1.5);


	textarea
		width 100%
		padding 10px
		font-size 15px
		box-sizing border-box
		border-radius 6px
		border none
		background-color #f3dfff

	input[type='button']
		border none
		font-family Oswald
		text-transform uppercase
		font-size 21px
		border-radius 5px
		background-color #71356f
		outline none
		color white
		padding 5px 15px
		line-height 30px
		margin-top 10px
		transition .3s all
		cursor pointer

		&:hover
			background-color #984695

.slideout
	&-menu
		position fixed
		top 0
		bottom 0
		width 256px
		height 100vh
		overflow hidden
		z-index 0
		display none
		background-color #1D1F20
		color white

		&-left
			left 0

		&-right
			right 0

	&-panel
		background-color white
		position relative
		z-index 1
		// will-change transform
		min-height 100vh

	&-open, &-open body, &-open &-panel
		overflow hidden

	&-open &-menu
		display block


</style>
